import {useSelector} from 'react-redux'
import {ACCOMMODATION_FIXED_HEADER_HEIGHT} from 'components/Accommodation/AccommodationFixedHeader/AccommodationFixedHeader'
import {getSearchDesktopHeaderHeight} from 'modules/search/selectors'
import {toggle} from 'opticks'

import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'

export const useAccommodationPageScrollTopOffset = () => {
  const {isDesktopMd, isDesktopLg, isMobile} = useDeviceLayout()

  const isSearchBoxSticky = toggle(
    '8d14a737-rsp-v2-improvements',
    false,
    isDesktopMd || isDesktopLg
  )

  const searchDesktopHeaderHeight = useSelector(getSearchDesktopHeaderHeight)

  const searchBoxOffset = isSearchBoxSticky ? searchDesktopHeaderHeight : 0
  const navBarOffset = isMobile ? 0 : ACCOMMODATION_FIXED_HEADER_HEIGHT

  const totalOffset = searchBoxOffset + navBarOffset

  return totalOffset
}
